/**
 * This module provides a global singleton for sharing staff data across components
 * without making duplicate API calls
 */

// Global shared cache for staff data
window.MYP_GLOBAL_STAFF_CACHE = window.MYP_GLOBAL_STAFF_CACHE || {
  // The actual staff data
  data: null,
  // Staff data as formatted select options
  staffOptions: null,
  // Flag to indicate if a request is in progress
  isLoading: false,
  // Array of callbacks to notify when data is loaded
  callbacks: [],
  // Register a callback to be notified when staff data is available
  onLoad: function(callback) {
    if (this.data) {
      // If data is already available, call the callback immediately
      callback(this.data);
    } else {
      // Otherwise add to the callback queue
      this.callbacks.push(callback);
    }
  },
  // Set the staff data and notify all registered callbacks
  setData: function(staffData) {
    this.data = staffData;
    this.isLoading = false;
    
    // Generate staff options once for reuse
    if (staffData && staffData.data) {
      this.staffOptions = staffData.data.map(s => ({
        value: s.staffId,
        label: s.person.name ? s.person.name.text : "",
        name: s.person.name
      }));
    }
    
    // Notify all callbacks
    this.callbacks.forEach(callback => {
      callback(staffData);
    });
    this.callbacks = [];
  }
};

export default window.MYP_GLOBAL_STAFF_CACHE;